import * as React from 'react';
import {
    Button,
    ButtonGroup,
    Row,
    Col,
    Checkbox,
    Panel,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    InputGroup
} from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import * as Features from '../../../../shared/Features';
import FormSelect from '../../../../components/common/FormSelect';
import {
    IBasicOrderInfo,
    Recipients,
    OrderTypes,
    IOwnerCommunicationViewModel,
    ISelectLanguageViewModel
} from './Types';

interface IProps {
    order: IBasicOrderInfo;
    viewEmails: () => void;
    viewSms: () => void;
    createMail: (recipient: Recipients) => void;
    createSms: (recipient: Recipients) => void;
    onPreventEmailsToBrokerChange: (e: any) => void;
    onPreventEmailsToPhotographerChange: (e: any) => void;
    onPreventCommunicationToPropertyOwnerChange: (e: any) => void;
    user: any;
    ownerCommunication: IOwnerCommunicationViewModel;
    ownerCommunicationLanguageChanged: (e: any) => void;
    extraDeliveryRecipients: string;
    onExtraDeliveryRecipientsChanged: (e: any) => void;
    updateExtraDeliveryRecipients: (extraDeliveryRecipients: string) => void;
}

const OrderCommunications = (props: IProps) => {
    return (
        <Col xs={12} md={5} lg={4}>
            <Panel>
                <Panel.Heading>
                    <h3 className="panel-title">
                        {Translate('view-order/basic-order-info/panel-headers/communication')}
                    </h3>
                </Panel.Heading>
                <Panel.Body>
                    {Features.hasFeature(Features.ViewOrderCommunications, props.user) && (
                        <Row>
                            <Col xs={12}>
                                <h5>
                                    {Translate(
                                        'view-order/basic-order-info/communication/labels/sent'
                                    )}
                                </h5>
                                <ButtonGroup justified>
                                    <Button
                                        href="#"
                                        bsStyle="info"
                                        className="communication-buttons"
                                        onClick={() => props.viewEmails()}
                                    >
                                        <i className="material-icons md-18"> email</i>
                                        {Translate(
                                            'view-order/basic-order-info/communication/button-labels/sent-email'
                                        )}
                                    </Button>
                                    <Button
                                        href="#"
                                        bsStyle="info"
                                        className="communication-buttons"
                                        onClick={() => props.viewSms()}
                                    >
                                        <i className="material-icons md-18"> sms</i>
                                        {Translate(
                                            'view-order/basic-order-info/communication/button-labels/sent-sms'
                                        )}
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    )}
                    {Features.hasFeature(Features.CreateOrderCommunication, props.user) && (
                        <Row>
                            <Col xs={12}>
                                <h5>
                                    {Translate(
                                        'view-order/basic-order-info/communication/labels/send-to-broker'
                                    )}
                                </h5>
                                <ButtonGroup justified>
                                    <Button
                                        href="#"
                                        bsStyle="primary"
                                        className="communication-buttons"
                                        onClick={() => props.createMail(Recipients.Customer)}
                                    >
                                        <i className="material-icons md-18">send</i>
                                        {Translate(
                                            'view-order/basic-order-info/communication/button-labels/mail-customer'
                                        )}
                                    </Button>
                                    <Button
                                        href="#"
                                        bsStyle="primary"
                                        className="communication-buttons"
                                        onClick={() => props.createSms(Recipients.Customer)}
                                    >
                                        <i className="material-icons md-18">sms</i>
                                        {Translate(
                                            'view-order/basic-order-info/communication/button-labels/sms-customer'
                                        )}
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    )}
                    {(props.order.orderType & OrderTypes.photo) > 0 &&
                        props.order.bookingInfo &&
                        props.order.bookingInfo.bookedTime &&
                        Features.hasFeature(Features.CreateOrderCommunication, props.user) && (
                            <Row>
                                <Col xs={12}>
                                    <h5>
                                        {Translate(
                                            'view-order/basic-order-info/communication/labels/send-to-photographer'
                                        )}
                                    </h5>
                                    <ButtonGroup justified>
                                        <Button
                                            href="#"
                                            bsStyle="primary"
                                            className="communication-buttons"
                                            onClick={() =>
                                                props.createMail(Recipients.Photographer)
                                            }
                                        >
                                            <i className="material-icons md-18">send</i>
                                            {Translate(
                                                'view-order/basic-order-info/communication/button-labels/mail-photographer'
                                            )}
                                        </Button>
                                        <Button
                                            href="#"
                                            bsStyle="primary"
                                            className="communication-buttons"
                                            onClick={() => props.createSms(Recipients.Photographer)}
                                        >
                                            <i className="material-icons md-18">sms</i>
                                            {Translate(
                                                'view-order/basic-order-info/communication/button-labels/sms-photographer'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        )}
                    {(props.order.orderType & OrderTypes.photo) > 0 &&
                        Features.hasFeature(Features.CreateOrderCommunication, props.user) && (
                            <Row>
                                <Col xs={12}>
                                    <h5>
                                        {Translate(
                                            'view-order/basic-order-info/communication/labels/misc'
                                        )}
                                    </h5>
                                    <ButtonGroup justified>
                                        <Button
                                            href="#"
                                            bsStyle="primary"
                                            className="communication-buttons"
                                            onClick={() => props.createMail(Recipients.Owner)}
                                        >
                                            <i className="material-icons md-18">send</i>
                                            {Translate(
                                                'view-order/basic-order-info/communication/button-labels/mail-owner'
                                            )}
                                        </Button>
                                        <Button
                                            href="#"
                                            bsStyle="primary"
                                            className="communication-buttons"
                                            onClick={() => props.createSms(Recipients.Owner)}
                                        >
                                            <i className="material-icons md-18">sms</i>
                                            {Translate(
                                                'view-order/basic-order-info/communication/button-labels/sms-owner'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        )}
                    {Features.hasFeature(Features.EditOrder, props.user) && (
                        <Row>
                            <Col xs={12}>
                                <Checkbox
                                    name="preventEmailsToBroker"
                                    checked={
                                        props.order.preventSystemEmailsToBroker
                                            ? props.order.preventSystemEmailsToBroker
                                            : false
                                    }
                                    onChange={props.onPreventEmailsToBrokerChange}
                                >
                                    <span>
                                        {Translate(
                                            'view-order/basic-order-info/communication/prevent-email-broker'
                                        )}
                                    </span>
                                </Checkbox>
                            </Col>
                        </Row>
                    )}
                    {(props.order.orderType & OrderTypes.photo) > 0 &&
                        Features.hasFeature(Features.EditOrder, props.user) && (
                            <Row>
                                <Col xs={12}>
                                    <Checkbox
                                        name="preventEmailsToPhotographer"
                                        checked={
                                            props.order.preventSystemEmailsToPhotographer
                                                ? props.order.preventSystemEmailsToPhotographer
                                                : false
                                        }
                                        onChange={props.onPreventEmailsToPhotographerChange}
                                    >
                                        <span>
                                            {Translate(
                                                'view-order/basic-order-info/communication/prevent-email-photographer'
                                            )}
                                        </span>
                                    </Checkbox>
                                </Col>
                            </Row>
                        )}
                    {(props.order.orderType & OrderTypes.photo) > 0 &&
                        Features.hasFeature(Features.EditOrder, props.user) && (
                            <Row>
                                <Col xs={12}>
                                    <Checkbox
                                        name="preventCommunicationToPropertyOwner"
                                        checked={
                                            props.order.preventCommunicationToPropertyOwner
                                                ? props.order.preventCommunicationToPropertyOwner
                                                : false
                                        }
                                        onChange={props.onPreventCommunicationToPropertyOwnerChange}
                                    >
                                        <span>
                                            {Translate(
                                                'view-order/basic-order-info/communication/prevent-communication-property-owner'
                                            )}
                                        </span>
                                    </Checkbox>
                                </Col>
                            </Row>
                        )}
                    {((props.order.orderType & OrderTypes.photo) > 0 ||
                        (props.order.orderType & OrderTypes.plan) > 0) &&
                        Features.hasFeature(Features.UpdateExtraDeliveryRecipients, props.user) && (
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <ControlLabel>
                                            {Translate(
                                                'view-order/basic-order-info/communication/extra-delivery-recipients'
                                            )}
                                        </ControlLabel>
                                        <InputGroup>
                                            <FormControl
                                                type="text"
                                                name="extraDeliveryRecipients"
                                                value={
                                                    props.extraDeliveryRecipients
                                                        ? props.extraDeliveryRecipients
                                                        : ''
                                                }
                                                onChange={props.onExtraDeliveryRecipientsChanged}
                                            />
                                            <InputGroup.Button>
                                                <Button
                                                    bsStyle="success"
                                                    className="communication-buttons"
                                                    onClick={() =>
                                                        props.updateExtraDeliveryRecipients(
                                                            props.extraDeliveryRecipients
                                                        )
                                                    }
                                                >
                                                    <i className="material-icons md-18">save</i>
                                                    {Translate(
                                                        'view-order/basic-order-info/communication/extra-delivery-recipients/save-button'
                                                    )}
                                                </Button>
                                            </InputGroup.Button>
                                        </InputGroup>
                                        <HelpBlock style={{ marginTop: '3px' }}>
                                            {Translate(
                                                'view-order/basic-order-info/communication/input-helptext/extra-delivery-recipients'
                                            )}
                                        </HelpBlock>
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}
                    {(props.order.orderType & OrderTypes.bookable) > 0 &&
                        Features.hasFeature(
                            Features.UpdateOwnerCommunicationLanguage,
                            props.user
                        ) &&
                        props.ownerCommunication && (
                            <dl>
                                <dt>
                                    {Translate(
                                        'view-order/basic-order-info/communication/labels/owner-language'
                                    )}
                                </dt>
                                <dd className="no-padding">
                                    <FormSelect
                                        name="languageKey"
                                        value={props.ownerCommunication.selectedLanguage}
                                        onChange={props.ownerCommunicationLanguageChanged}
                                    >
                                        {props.ownerCommunication.availableLanguages.map(
                                            (x: ISelectLanguageViewModel, index: number) => (
                                                <option key={x.id} value={x.id}>
                                                    {Translate(x.displayName)}
                                                </option>
                                            )
                                        )}
                                    </FormSelect>
                                </dd>
                            </dl>
                        )}
                </Panel.Body>
            </Panel>
        </Col>
    );
};

export default OrderCommunications;
